module.exports = __webpack_public_path__ + "img/gears-icon-2.b5bd9f91.svg";